import {useTranslations} from 'next-intl';
import Container from '@/container';
import {Row, Col} from '@/grid';
import {Grid} from '@/content/features/shared';
import {SectionPaddingHalfTop, SectionPaddingHalfBottom} from '@/section';
import {H1, P} from '@/typography';
import {withBgNeutral200, withGreen800, withNeutral700, withNeutral800} from '@/hocs/withColors';
import {withHeadingEyebrow, withHomeSubP, withUppercase} from '@/hocs/withFontType';
import {withNoMarginBottom} from '@/hocs/withSpacing';

const BgSectionPaddingHalfBottom = withBgNeutral200(SectionPaddingHalfBottom);
const EyebrowNeutral700 = withNeutral700(withUppercase(withHeadingEyebrow(P)));
const H1Green800 = withGreen800(H1);
const SubPNeutral800 = withNoMarginBottom(withNeutral800(withHomeSubP(P)));

const CustomersHero = () => {
  const t = useTranslations('customers.hero');

  return (
    <BgSectionPaddingHalfBottom>
      <Container variant="section-padding-below-nav">
        <SectionPaddingHalfTop>
          <Grid fluid>
            <Row center="xs">
              <Col xs={12} lg={8}>
                <EyebrowNeutral700>{t('eyebrow')}</EyebrowNeutral700>
                <H1Green800>{t('title')}</H1Green800>
                <SubPNeutral800>{t('subtitle')}</SubPNeutral800>
              </Col>
            </Row>
          </Grid>
        </SectionPaddingHalfTop>
      </Container>
    </BgSectionPaddingHalfBottom>
  );
};

export default CustomersHero;
